import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgCloseParenthesis = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    x={0}
    y={0}
    viewBox="0 0 17 56.7"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M1.9 2.2c1.3.2 2.4.7 3.4 1.5.8.8 1.5 1.8 2 2.9.9 2.3 3.1 8.4 3.1 21.8S8.2 47.8 7.3 50.1c-.5 1.1-1.2 2.1-2 2.9Q3.8 54.2 2 54.5h-.1c-.4.1-.6.4-.6.8.1.3.3.6.6.6 1.6.2 3.2-.1 4.7-.8 1.4-.8 2.7-1.9 3.6-3.2q2.55-3.9 3.6-8.4l.1-.3c2.5-9.7 2.5-19.8 0-29.5l-.1-.3Q12.75 8.9 10.2 5C9.3 3.5 8 2.4 6.6 1.6 5.1.9 3.5.7 1.9.9c-.4 0-.7.4-.6.7 0 .3.2.6.6.6"
      fill="currentColor"
    />
  </svg>
);
